<ul class="menu-list" *ngFor="let group of (global$ | async)?.groups"
    [ngClass]="(selectedGroup && selectedGroup == group.name) ? 'is-active' : '' ">
    <li>
        <a (click)="setSelectedGroup(group.name)" class="is-size-6 is-size-5-widescreen "
           [ngClass]="(selectedGroup && selectedGroup == group.name) ? 'is-active' : '' ">{{group.name}}</a>
        <ul>
            <li>
                <a [routerLink]="'/sortiment/' + encodeURIComponent(group.name)"
                   (click)="selectedGroup1 = undefined;">Alle
                    Artikel anzeigen</a></li>

            <li *ngFor="let group1 of group.groups1">
                <a (click)="navigateToGroup1(group.name, group1.name); setSelectedGroup1(group1.name)"
                   [ngClass]="((selectedGroup1 && selectedGroup1 == group1.name)) ? 'is-active' : '' ">{{group1.name}}</a>
            </li>


        </ul>
    </li>
</ul>
